import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { formValidation } from '../functions/Validation';
import Question from '../components/question/Question';
import FormTitle from '../title/FormTitle';
import BackToTop from '../components/backToTop/BackToTop';
/*import TagManager from 'react-gtm-module';*/
import { enableQuestionsInSet, showConditionalQuestionsInSet } from '../functions/QuestionEnabling';
import { GetLimitedCompanyQuestions, GetPartnershipQuestions, GetSoleTraderQuestions } from '../functions/ShortFormQuestions';
import { AnswerType } from '../enums/AnswerType';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { GetTradeByName } from '../functions/Trades';
import { isShortJourney } from '../functions/JourneyLength';
import { IsWebReferenceSuffix } from '../functions/Configuration';

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'aboutyou'
//    },
//    dataLayerName: 'AboutYouPageDataLayer'
//}

export default function AboutYou(props: any) {
    const navigate = useNavigate();
    const location = useLocation();

    var getUrlParameter = function getUrlParameter(sParam: string) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                if (sParam === "affid" || sParam === "gclid") {
                    let returnValue = null;
                    if (sParameterName[1] !== undefined) {
                        returnValue = decodeURIComponent(sParameterName[1]);

                        if (sParameterName[2] !== undefined) {
                            returnValue = returnValue + "=" + decodeURIComponent(sParameterName[2]);
                        }
                    }
                    return returnValue;
                } else {
                    return sParameterName[1] === undefined ? "" : decodeURIComponent(sParameterName[1]);
                }
            }
        }
        return "";
    };

    //let urlParams = new URLSearchParams(window.location.search);

    const [questions, setQuestions] = useState<any[]>([]);
    const [trade, setTrade] = useState<any>();
    const [status, setStatus] = useState<any>();
    const [tradeDescription, setTradeDescription] = useState<string>("");
    const [statusDescription, setStatusDescription] = useState<string>("");
    const [customerDetails, setCustomerDetails] = useState<CustomerDetails>({
        "activityID": getUrlParameter("activityId") !== "" ? getUrlParameter("activityId") : null,
        "address": {
            "house": null,
            "street": null,
            "locality": null,
            "city": null,
            "county": null,
            "country": null,
            "postcode": null
        },
        "agentID": null,
        "businessTelephoneNumber": null,
        "campaignID": null,
        "contactName": null,
        "contactPreferences": {
            "email": false,
            "emailSpecified": false,
            "letter": false,
            "letterSpecified": false,
            "phone": false,
            "phoneSpecified": false,
            "sms": false,
            "smsSpecified": false
        },
        "dob": null,
        "email": null,
        "filingCode": getUrlParameter("filingcode") !== "" ? getUrlParameter("filingcode") : null,
        "forename": null,
        "homeTelephoneNumber": null,
        "insuredPartyHID": 0,
        "insuredPartyHIDSpecified": false,
        "insuredPartyID": null,
        "ipAddress": getUrlParameter("remoteIpAddress") !== "" ? getUrlParameter("remoteIpAddress") : null,
        "isCompany": false,
        "isCompanySpecified": false,
        "isConverted": false,
        "isConvertedSpecified": false,
        "loginErrorMessage": null,
        "marketingReference": getUrlParameter("affid") !== "" ? getUrlParameter("affid") : null,
        "mobile": null,
        "mothersMaidenName": null,
        "password": null,
        "policyDetailsHID": 0,
        "policyDetailsHIDSpecified": false,
        "policyDetailsID": null,
        "policyNumber": null,
        "policyStartDate": new Date().toISOString(),
        "policyStartDateSpecified": false,
        "policyStatus": null,
        "prefferedMethodContact": null,
        "productID": null,
        "productType": 0,
        "productTypeSpecified": false,
        "sourceOfBusinessID": null,
        "stopAtRenewal": false,
        "stopAtRenewalSpecified": false,
        "surname": null,
        "title": null,
        "webReference": getUrlParameter("webReference") !== "" ? getUrlParameter("webReference") : null,
        "websiteAddress": null
    });
    const [readyToNavigate, setReadyToNavigate] = useState(false);
    const [siteConfig, setSiteConfig] = useState(JSON.parse(localStorage.getItem('siteConfig') || "{}"));

    const pageNo: number = 0;
    const webReference = getUrlParameter("webReference") || "";

    /*TagManager.dataLayer(tagManagerArgs);*/
    props.setSidebarVisibility(true);

    useEffect(() => {
        props.setCurrentPage(pageNo);
        props.setSidebarVisibility(siteConfig.sidebarEnablement);
        
        if (window.location.search.substring(1).split('&').length > 0) {
            let status = getUrlParameter("type");
            let tradeName = getUrlParameter("trade");
            let gclid = getUrlParameter("gclid") !== "" ? getUrlParameter("gclid") : null;
            let aboutYouQuestions: any[] = [];

            if (status === "limited") {
                aboutYouQuestions = GetLimitedCompanyQuestions();
                setStatusDescription("Limited Company");
            }

            if (status === "partner") {
                aboutYouQuestions = GetPartnershipQuestions();
                setStatusDescription("Partnership");
            }

            if (status === "trader") {
                aboutYouQuestions = GetSoleTraderQuestions();
                setStatusDescription("Sole Trader");
            }

            if (IsWebReferenceSuffix(webReference, "RPO")) {
                aboutYouQuestions.forEach(question => {
                    let questionText = question.questionSetQuestion.text.toLowerCase() || "";
                    let placeHolder = question.placeholder?.toLowerCase() || "";

                    if (questionText.includes("date of birth")) {
                        question.questionSetQuestion.enabled = false;
                    }
                    if (placeHolder.includes("email")) {
                        question.placeholder = "Your email address";    
                    }
                    if (placeHolder.includes("business postcode")) {
                        question.placeholder = "Your correspondence postcode & search";
                    }
                    if (placeHolder.includes("contact number")) {
                        question.placeholder = "Your contact number";
                    }
                });
            }
            setQuestions(aboutYouQuestions);

            localStorage.setItem('status', status ? status : "");

            if (tradeName != null) {
                let tradeObject = GetTradeByName(tradeName);
                setTrade(tradeObject);
                setTradeDescription(tradeObject.description);
                localStorage.setItem('trade', JSON.stringify(tradeObject));
            }

            setStatus(status);

            localStorage.removeItem("customerDetails");

                const newCustomerDetails = {
                    "activityID": getUrlParameter("activityId") !== "" ? getUrlParameter("activityId") : null,
                    "address": {
                        "house": null,
                        "street": null,
                        "locality": null,
                        "city": null,
                        "county": null,
                        "country": null,
                        "postcode": null
                    },
                    "agentID": null,
                    "businessTelephoneNumber": null,
                    "campaignID": null,
                    "contactName": null,
                    "contactPreferences": {
                        "email": false,
                        "emailSpecified": false,
                        "letter": false,
                        "letterSpecified": false,
                        "phone": false,
                        "phoneSpecified": false,
                        "sms": false,
                        "smsSpecified": false
                    },
                    "dob": null,
                    "email": null,
                    "filingCode": getUrlParameter("filingcode") !== "" ? getUrlParameter("filingcode") : null,
                    "forename": null,
                    "homeTelephoneNumber": null,
                    "insuredPartyHID": 0,
                    "insuredPartyHIDSpecified": false,
                    "insuredPartyID": null,
                    "ipAddress": getUrlParameter("remoteIpAddress") !== "" ? getUrlParameter("remoteIpAddress") : null,
                    "isCompany": false,
                    "isCompanySpecified": false,
                    "isConverted": false,
                    "isConvertedSpecified": false,
                    "loginErrorMessage": null,
                    "marketingReference": getUrlParameter("affid") !== "" ? getUrlParameter("affid") : null,
                    "mobile": null,
                    "mothersMaidenName": null,
                    "password": null,
                    "policyDetailsHID": 0,
                    "policyDetailsHIDSpecified": false,
                    "policyDetailsID": null,
                    "policyNumber": null,
                    "policyStartDate": new Date().toISOString(),
                    "policyStartDateSpecified": false,
                    "policyStatus": null,
                    "prefferedMethodContact": null,
                    "productID": null,
                    "productType": 0,
                    "productTypeSpecified": false,
                    "sourceOfBusinessID": null,
                    "stopAtRenewal": false,
                    "stopAtRenewalSpecified": false,
                    "surname": null,
                    "title": null,
                    "webReference": getUrlParameter("webReference") !== "" ? getUrlParameter("webReference") : null,
                    "websiteAddress": null
                }

                localStorage.setItem('customerDetails', JSON.stringify(newCustomerDetails));
                setCustomerDetails(newCustomerDetails);

            localStorage.setItem('gclid', gclid ? gclid : "");
            var trackingUrl = getUrlParameter("displayUrl");
            if (trackingUrl != null) {
                tracking(Action.SAVE_SHORTFORM, undefined, trackingUrl);
            } else {
                tracking(Action.SAVE_SHORTFORM);
            }
            localStorage.setItem('shortJourney', isShortJourney(getUrlParameter("webReference")));
        }
    }, [])

    useEffect(() => {
        localStorage.setItem('customerDetails', JSON.stringify(customerDetails));
        if (readyToNavigate) {
            
            let browserType = getUrlParameter("browserType");
            if (browserType === null) {
                browserType = "";
            }
            localStorage.setItem('browserType', browserType);

            let deviceType = getUrlParameter("deviceType");
            if (deviceType === null) {
                deviceType = "";
            }
            localStorage.setItem('deviceType', deviceType);

            let isMobile = getUrlParameter("isMobile");
            if (isMobile === null) {
                isMobile = "";
            }
            localStorage.setItem('isMobile', isMobile);

            var trackingUrl = getUrlParameter("displayUrl");
            if (trackingUrl != null) {
                tracking(Action.SAVE_SHORTFORM, undefined, trackingUrl);
            } else {
                tracking(Action.SAVE_SHORTFORM);
            }

            navigate("/Loading", {
                state: {
                    trade: { trade },
                    status: { status },
                    pageToLoad: "/YourBusiness",
                    loadingTitle: "Loading",
                    loadingMessage: "Retrieving questions",
                    customerDetails: { customerDetails }
                }
            });
        }
    }, [readyToNavigate])

    const nextNavigation = () => {
        let formValid = true;
        try {
            var updatedQuestions = questions.map(question => {
                if (question.page === pageNo) {
                    //if the question has already failed another validation then set the formValid to false
                    if (question.validationFail) {
                        formValid = false;
                    } else {
                        if (formValidation(question)) {
                            question.validationFail = false;
                        } else {
                            formValid = false;
                            question.validationFail = true;
                        }
                    }
                }
                if (question.childInformation != null) {
                    question.childInformation.map((childquestion: any) => {
                        if (childquestion.page === pageNo) {
                            //if the question has already failed another validation then set the formValid to false
                            if (childquestion.validationFail) {
                                formValid = false;
                            } else {
                                if (formValidation(childquestion)) {
                                    childquestion.validationFail = false;
                                } else {
                                    if ((question.questionSetQuestion.childQuestionRepeatMinimum > 0 && childquestion.index > 0) || question.questionSetQuestion.childQuestionRepeatMinimum === 0 || question.questionSetQuestion.childQuestionRepeatMinimum == null) {
                                        formValid = false;
                                        childquestion.validationFail = true;
                                    }
                                }
                            }
                        }
                        if (childquestion.questionSetQuestion.text === "Postcode" && !childquestion.questionSetQuestion.visible) {
                            question.validationFail = true;
                            formValid = false;
                        }

                        return childquestion;
                    });
                }
                return question;
            });
            if (formValid) {
                setReadyToNavigate(true);
            } else {
                setQuestions(updatedQuestions);
            }
        }
        catch (e) {
            navigate("/Error", {
                state: {
                    errorTitle: "About You page Error",
                    errorMessage: "Unknown error occured while processing 'About You' page",
                },
            });
        }
    }

    const showConditionQuestions = (questionID: any, value: any) => {
        let newQuestions = showConditionalQuestionsInSet(questions, questionID, value);
        setQuestions(newQuestions);
    }

    const setCustomerDetailsAddress = (address: Address) => {
        let customer = customerDetails;
        customer.address = address;
        setCustomerDetails(customer);
    }

    const setIndividualCustomerDetails = (question: any) => {
        let customerDetailsUpdated = false;
        let updatedCustomerDetails = customerDetails;
        let updatedAddress: Address = {};

        if (updatedCustomerDetails.address) {
            updatedAddress = updatedCustomerDetails.address;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("date of birth") && !customerDetails.isCompany) {
            updatedCustomerDetails.dob = question.answer;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("title") && !customerDetails.isCompany) {
            if (question.questionSetQuestion.answerTypeId === AnswerType.ListBox && question.answer !== "") {
                let dropdownItem = question.answerList.filter((x: { value: any; }) => x.value === question.answer);
                updatedCustomerDetails.title = dropdownItem[0].value;
            } else {
                updatedCustomerDetails.title = question.answer;
            }

            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("forename") && !customerDetails.isCompany) {
            updatedCustomerDetails.forename = question.answer;
            updatedCustomerDetails.contactName = question.answer + " " + (updatedCustomerDetails?.surname ?? "");
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("surname") && !customerDetails.isCompany) {
            updatedCustomerDetails.surname = question.answer;
            updatedCustomerDetails.contactName = (updatedCustomerDetails?.forename ?? "") + " " + question.answer;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "postcode") {
            var updatedQuestions = questions.map(questionObject => {
                if (questionObject.questionSetQuestion.text.toLowerCase().includes("postcode")) {
                    questionObject.answer = question.answer;
                    questionObject.validationFail = false;
                }
                return questionObject;
            });
            setQuestions(updatedQuestions);
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("business name") || question.questionSetQuestion.text.toLowerCase().includes("trading name")) {
            updatedCustomerDetails.surname = question.answer;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("business contact")) {
            updatedCustomerDetails.contactName = question.answer;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("email address")) {
            updatedCustomerDetails.email = question.answer;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase().includes("telephone number")) {
            var updatedQuestions = questions.map(questionObject => {
                if (questionObject.questionSetQuestion.text.toLowerCase().includes("telephone number")) {
                    
                    questionObject.answer = questionObject.answer.replace("+44", "0");

                    if (questionObject.answer.length > 1 && !questionObject.answer.startsWith("0")) {
                        questionObject.answer = "0" + questionObject.answer;
                    }

                    var updateAnswerEvent = new CustomEvent("updateAnswer", {
                        "detail": { "questionID": questionObject.questionSetQuestion.questionID, "answer": questionObject.answer }
                    });

                    document.dispatchEvent(updateAnswerEvent);

                }
                return questionObject;
            });
            setQuestions(updatedQuestions);


            updatedCustomerDetails.mobile = question.answer;
            updatedCustomerDetails.homeTelephoneNumber = question.answer;
            updatedCustomerDetails.businessTelephoneNumber = question.answer;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "house") {
            updatedAddress.house = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "street") {
            updatedAddress.street = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "locality") {
            updatedAddress.locality = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "town") {
            updatedAddress.locality = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "city") {
            updatedAddress.city = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "country") {
            updatedAddress.country = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "county") {
            updatedAddress.county = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (question.questionSetQuestion.text.toLowerCase() === "postcode") {
            updatedAddress.postcode = question.answer;
            updatedCustomerDetails.address = updatedAddress;
            customerDetailsUpdated = true;
        }

        if (customerDetailsUpdated) {
            setCustomerDetails(updatedCustomerDetails);
        }
    }

    const enableQuestions = (questionID: number) => {
        let newQuestions = enableQuestionsInSet(questions, questionID);
        setQuestions(newQuestions);
    }

    const resetRelatedQuestionsValidationOnAnswerChange = (questionID: number) => {
    }

    return (
        <>
            <div className="form-container">
                <FormTitle title="Contact Information" />
                {IsWebReferenceSuffix(webReference, "RPO") &&
                    <>
                        <p>To get us started with your quote, please provide a few details below</p>
                        <div className="section-header">About You</div>
                    </> ||
                    <>
                        <p>To get us started with your quote, please provide a few details about you and the company below</p>
                        <div className="section-header">Your Details</div>
                    </>}
                
                

                {questions.map((question, index) => {
                    return (<div key={index}>
                        <Question question={question} key={question.questionSetQuestion.questionID} showConditionQuestions={showConditionQuestions} enableQuestions={enableQuestions} resetRelatedQuestionsValidationOnAnswerChange={resetRelatedQuestionsValidationOnAnswerChange} setCustomerDetailsAddress={setCustomerDetailsAddress} page={pageNo} setIndividualCustomerDetails={setIndividualCustomerDetails} />
                    </div>)
                }
                )}
                <div className="btn-container">
                    <button className="btn primary" onClick={() => nextNavigation()}>Next</button>
                </div>
            </div>
            <BackToTop />
        </>
    )
}